export class Identity {}

export default Identity;
